import React from 'react';

/**
 * AuthBackground Component
 * 
 * Renders the animated glowing rectangle background for auth pages (login/register).
 * Different from WaveBackground - uses thin vertical and horizontal glowing rectangles
 * with diagonal positioning and movement animations.
 * 
 * Exact styles from auth.css:
 * - Vertical rectangles: 80-100px width, 130-140vh height
 * - Horizontal rectangles: 100vw+ width, 55-70px height
 * - Border radius: 40px
 * - Opacity: 0.6 with animation between 0.5-0.6
 * - Blur: 1px
 * - Box shadows: 0 0 40px rgba(255, 255, 255, 0.08)
 * - Animations: 18-25s ease-in-out infinite
 */
const AuthBackground = () => {
  return (
    <div 
      className="auth-background fixed top-0 left-0 w-full h-full z-0 pointer-events-none overflow-hidden"
      style={{
        width: '100%',
        left: 0,
        right: 0
      }}
    >
      {/* Vertical Glowing Rectangles */}
      <div
        className="glow-rect-vertical glow-rect-vertical-1 absolute animate-move-rect-1"
        style={{
          width: '90px',
          height: '140vh',
          top: '-20vh',
          left: '15%',
          transform: 'translateX(-50%) rotate(25deg)',
          background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.28) 20%, rgba(240, 240, 240, 0.18) 40%, rgba(180, 180, 180, 0.11) 60%, rgba(100, 100, 100, 0.05) 80%, transparent 100%)',
          filter: 'blur(1px)',
          boxShadow: '0 0 40px rgba(255, 255, 255, 0.08), inset 0 0 30px rgba(255, 255, 255, 0.04)',
          borderRadius: '40px',
          opacity: 0.6,
        }}
      />

      <div
        className="glow-rect-vertical glow-rect-vertical-2 absolute animate-move-rect-2"
        style={{
          width: '70px',
          height: '130vh',
          top: '-15vh',
          left: '70%',
          transform: 'translateX(-50%) rotate(-30deg)',
          background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.28) 20%, rgba(240, 240, 240, 0.18) 40%, rgba(180, 180, 180, 0.11) 60%, rgba(100, 100, 100, 0.05) 80%, transparent 100%)',
          filter: 'blur(1px)',
          boxShadow: '0 0 40px rgba(255, 255, 255, 0.08), inset 0 0 30px rgba(255, 255, 255, 0.04)',
          borderRadius: '40px',
          opacity: 0.6,
        }}
      />

      <div
        className="glow-rect-vertical glow-rect-vertical-3 absolute animate-move-rect-3"
        style={{
          width: '100px',
          height: '135vh',
          top: '-18vh',
          right: '15%',
          transform: 'translateX(50%) rotate(35deg)',
          background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.28) 20%, rgba(240, 240, 240, 0.18) 40%, rgba(180, 180, 180, 0.11) 60%, rgba(100, 100, 100, 0.05) 80%, transparent 100%)',
          filter: 'blur(1px)',
          boxShadow: '0 0 40px rgba(255, 255, 255, 0.08), inset 0 0 30px rgba(255, 255, 255, 0.04)',
          borderRadius: '40px',
          opacity: 0.6,
        }}
      />

      {/* Horizontal Glowing Rectangles */}
      <div
        className="glow-rect-horizontal glow-rect-horizontal-1 absolute animate-move-rect-h-1"
        style={{
          width: '120vw',
          height: '55px',
          top: '25%',
          left: '-5%',
          transform: 'rotate(-15deg)',
          background: 'linear-gradient(45deg, transparent 0%, rgba(255, 255, 255, 0.4) 10%, rgba(255, 255, 255, 0.28) 30%, rgba(240, 240, 240, 0.18) 50%, rgba(180, 180, 180, 0.11) 70%, rgba(100, 100, 100, 0.05) 90%, transparent 100%)',
          filter: 'blur(1px)',
          boxShadow: '0 0 40px rgba(255, 255, 255, 0.08), inset 0 0 30px rgba(255, 255, 255, 0.04)',
          borderRadius: '40px',
          opacity: 0.6,
        }}
      />

      <div
        className="glow-rect-horizontal glow-rect-horizontal-2 absolute animate-move-rect-h-2"
        style={{
          width: '115vw',
          height: '70px',
          bottom: '30%',
          right: '-3%',
          transform: 'rotate(20deg)',
          background: 'linear-gradient(45deg, transparent 0%, rgba(255, 255, 255, 0.4) 10%, rgba(255, 255, 255, 0.28) 30%, rgba(240, 240, 240, 0.18) 50%, rgba(180, 180, 180, 0.11) 70%, rgba(100, 100, 100, 0.05) 90%, transparent 100%)',
          filter: 'blur(1px)',
          boxShadow: '0 0 40px rgba(255, 255, 255, 0.08), inset 0 0 30px rgba(255, 255, 255, 0.04)',
          borderRadius: '40px',
          opacity: 0.6,
        }}
      />
    </div>
  );
};

export default AuthBackground;

